import { useNavigate } from "react-router-dom";
import { useAllSuborgsDashboard } from "../../../context/SuperAdmin/DashboardContexts/AllSuborgs";
import SingleTotalCreditos from "../../../components/Table/Dashboard/SingleEntity/SingleTotalCreditos";
import SingleMonthlyCredits from "../../../components/Table/Dashboard/SingleEntity/SingleMonthlyCredits";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { Button, Grid, Typography } from "@mui/material";
import SelectTypeOfDashboard from "../../../components/Table/Dashboard/SelectTypeOfDashboard";

const SingleSuborgDashboard = () => {
  const {
    selectedSuborg,
    isLoadingTotalCredits,
    isLoadingMonthlyCredits,
    monthlyCredits,
    months,
    startMonth,
    monthlyCreditsFilters,
    changeMonths,
    updateStartingMonth,
    handleToggleMonthlyCredit,
  } = useAllSuborgsDashboard();
  const navigate = useNavigate();

  if (!selectedSuborg) return null;
  return (
    <SelectTypeOfDashboard routeValue="users">
      {/* Header de Single Suborg */}
      <Grid
        container
        sx={{ justifyContent: "space-between", alignItems: "center" }}
      >
        {/* Título */}
        <Grid item>
          <Typography
            variant={"h5"}
            sx={{ color: "#005559", fontSize: "24px" }}
          >
            <b>Suborganización</b> | {selectedSuborg?.suborganizacion}
          </Typography>
        </Grid>

        {/* Boton para volver */}
        <Grid item>
          <Button sx={{ color: "#336B87" }} onClick={() => navigate(-1)}>
            <ArrowBackOutlinedIcon />
            Volver
          </Button>
        </Grid>
      </Grid>

      {/* Pie Charts con el resume de los créditos totales */}
      <SingleTotalCreditos
        credits={selectedSuborg}
        isLoading={isLoadingTotalCredits}
      />

      {/* Créditos mensuales */}
      <SingleMonthlyCredits
        isLoading={isLoadingMonthlyCredits}
        monthlyCredits={monthlyCredits}
        startMonth={startMonth}
        months={months}
        changeMonths={changeMonths}
        updateStartingMonth={updateStartingMonth}
        creditsFilters={monthlyCreditsFilters}
        handleToggleCredit={handleToggleMonthlyCredit}
      />
    </SelectTypeOfDashboard>
  );
};

export default SingleSuborgDashboard;
